export const getSubdomain = (): string | undefined => {
  const hostParts = window.location.hostname.split(".");
  if (hostParts.length > 2) {
    return hostParts[0];
  }
};
